import { stateStatusType, VideoSeasonProps } from './actionType';

// FetchVideoSeasonState
export interface FetchVideoSeasonsState {
    isLoading: boolean;
    error: string | null;
    video_seasons: VideoSeasonProps[];
    status: stateStatusType | null;
}
export interface GenericVideoSeasonsState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export const initialVideoSeasonState: FetchVideoSeasonsState = {
    isLoading: false,
    error: null,
    video_seasons: [],
    status: null
};
export const initialGenericVideoSeasonState: GenericVideoSeasonsState = {
    isLoading: false,
    error: null,
    status: null,
};

export interface VideoSeasonsState {
    videoSeasonsState: FetchVideoSeasonsState;
    genericVideoSeasonState: GenericVideoSeasonsState;

}

export const initialState: VideoSeasonsState = {
    videoSeasonsState: initialVideoSeasonState,
    genericVideoSeasonState: initialGenericVideoSeasonState
};


